module Meevo.Components.Controls.SmartMover {
    import Manufacturer = Model.Manufacturer;

    export class ProductVariantToProductCatStrategy implements ICollectionPopulate {
        constructor(private parent: ICollectionBase<Model.ProductCategory>, private child: ICollectionBase<Model.Variant>) {
        }

        populate(): void {
            const groups = _.groupBy(this.child.models, variant => variant.get('manufacturerId') + '_' + variant.get('categoryId'));
            for (const cat of this.parent.models) {
                const key = cat.get('manufacturerId') + '_' + cat.get('id');
                const variants = groups[key] || [];
                (<ISmartMoverCategoryModel<Model.ProductCategory>>cat).resetModels(variants);
            }
        }
    }

    export class CoreProductVariantToCategoryStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<Model.ProductCategory>, public child: ICollectionBase<Model.Variant>) {
        }

        populate(): void {
            for (const category of this.parent.models) {
                const categoryId = category.get('id');
                (<ISmartMoverCategoryModel<Model.ProductCategory>>category).resetModels(
                    this.child.models.filter((variant) => variant.get('categoryId') === categoryId)
                );
            }
        }
    }
}
